import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, filter, first, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface RequestCacheEntry {
  url: string;
  response: Observable<HttpEvent<any>>;
  lastRead: number;
}

@Injectable({ providedIn: 'root' })
export class CacheIntercetpor2 implements HttpInterceptor {
  public readonly store: Record<string, Observable<HttpEvent<any>>> = {};

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.method !== 'GET') {
      return next.handle(req);
    }

    if (req.headers.get('Cache-Control') === 'no-cache') {
      if (environment.debug) {
        console.log('Purge cache for', req.urlWithParams);
      }
      delete this.store[req.urlWithParams];
    }

    if (this.store[req.urlWithParams]) {
      return this.store[req.urlWithParams].pipe(first());
    }

    this.store[req.urlWithParams] = next.handle(req).pipe(
      filter((res) => res instanceof HttpResponse),
      shareReplay(1),
    );

    return this.store[req.urlWithParams].pipe(first());
  }
}
